export const getTheme = (theme) => ({
	...theme,
	colors: {
		...theme.colors,
		primary25: '#f3f6f9',
		primary50: '#dcdcdc',
		primary: '#dcdcdc',
	}
});